import Api from "@/services/Index";

const setBaseUrl = () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
};

const getDashboardStatsInformation = async (config) => {
    setBaseUrl();
    return Api.get("/accounts-receivables/summary", config);
};

const getAll = (config) => {
    setBaseUrl();
    return Api.get("/accounts-receivables", config);
};

const exportExcel = (config) => {
    setBaseUrl();
    return Api.get("/accounts-receivables/excel-export", {...config,responseType:'arraybuffer'});
};

const sendToCfo = (data) => {
    setBaseUrl();
    return Api.post("/accounts-receivables/send-to-cfo", data);
};

const updateCollectionReferralDate = (data) => {
    setBaseUrl();
    return Api.post("/accounts-receivables/collection-referral-date", data);
};

const getOne = (id) => {
    setBaseUrl();
    return Api.get(`/accounts-receivables/${id}`);
};

const update = (id, data) => {
    setBaseUrl();
    return Api.put(`/accounts-receivables/${id}`, data);
};


const getLogs = (id) => {
    setBaseUrl();
    return Api.get(`/accounts-receivable/${id}/logs`);
};

export default {
    getDashboardStatsInformation,
    getAll,
    exportExcel,
    sendToCfo,
    getOne,
    update,
    updateCollectionReferralDate,
    getLogs
};
